import {getVideoComments} from '../../../redux/management/managementActions';
import {TFunction} from 'react-i18next';
import {exportToExcel} from '../../../pages/components/exportExcel/ExcelExportButton';
import {bounceMessage} from '../../userMessages/UserMessage';

interface CommentData {
    videoTitle: string;
    videoId: number;
    userId: number;
    rating: number | null;
    ratingTime: string | null;
    ratingTimeUnix: number | null;
    commentText: string;
    urid: number | null;
    pid: number | null;
    eid: number | null;
    userRatingId: number;
}

interface CommentsResponse {
    videoTitle: string;
    comments: CommentData[];
}

export const exportVideoCommentsToExcel = async (
    videoId: number,
    t: TFunction,
    lang: string
): Promise<void> => {
    try {
        const commentsData = await getVideoComments(videoId) as CommentsResponse;
        
        if(!commentsData || !commentsData.comments || commentsData.comments.length === 0) {
            bounceMessage(t('noCommentsToExport'), 'attention');
            return;
        }
        
        // Prepare data for Excel export
        const excelData = commentsData.comments.map((comment: CommentData) => ({
            [t('videoTitle')]: comment.videoTitle || '',
            [t('videoId')]: comment.videoId || '',
            [t('userId')]: comment.userId || '',
            [t('rating')]: comment.rating || '',
            [t('ratingTime')]: comment.ratingTime || '',
            [t('commentText')]: comment.commentText || '',
            [t('urid')]: comment.urid || '',
            [t('pid')]: comment.pid || '',
            [t('eid')]: comment.eid || ''
        }));
        
        const videoTitle = commentsData.videoTitle || 'video';
        
        // Excel sheet names are limited to 31 characters
        const sheetName = videoTitle.substring(0, 31);
        
        exportToExcel(sheetName, excelData, lang);
    } catch (error) {
        console.error('Error exporting comments:', error);
        bounceMessage(t('errorExportingComments'), 'attention');
    }
};
